import { post } from '@/common/request/index';

const OPTIONS = { isMock: false, mockId: 0, mockSuffix: '/api', needHint: true, isRes: true, needCancel: false };

/** 资源服务动态树形选择：按数据源、关键词和已选 ID 查询选项。 */
export function searchDynamicTreeOptions(params: any) {
  return post('/dropDownList/search', params, OPTIONS);
}
